import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaKey } from 'react-icons/fa';
import '../assets/styles/Style.css';
import '../assets/styles/header.css';
import { baricon, baricon1, loginlogo, user06 } from './imagepath';
import { useAuth } from '../utils/AuthContext';
import { getAppContext } from '../config/appContext';
import { ROLE_LABELS } from '../config/tenantRoles';

const formatRole = (rol) => {
  if (!rol) return 'Usuario';
  return ROLE_LABELS[String(rol).toLowerCase()] || rol;
};

const formatDisplayName = (user) => {
  if (!user) return 'Usuario';
  const fullName = [user.nombre, user.apellido].filter(Boolean).join(' ').trim();
  return fullName || user.nombre || 'Usuario';
};

const Header = () => {
  const { user, logout } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1070);

  const empresa = useMemo(() => {
    if (user?.empresa) return user.empresa;
    const slug = getAppContext().tenantSlug;
    if (!slug) return null;
    return slug.charAt(0).toUpperCase() + slug.slice(1);
  }, [user?.empresa]);

  const displayName = formatDisplayName(user);
  const roleLabel = formatRole(user?.rol);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1070);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handlesidebar = () => {
    document.body?.classList.toggle('mini-sidebar');
  };

  const handlesidebarmobilemenu = () => {
    const body = document.body;
    const html = document.documentElement;
    const sidebarOverlay = document.querySelector('.sidebar-overlay');

    body?.classList.toggle('slide-nav');
    html?.classList.toggle('menu-opened');
    sidebarOverlay?.classList.toggle('opened');
  };

  return (
    <div className="header rentahab-header">
      <div className="header-left">
        <Link to="/admin-dashboard" className="logo">
          <img src={loginlogo} alt="RentAHAB" />
          <span className="logo-text">
            <strong>RentAHAB</strong>
            {empresa && <small>{empresa}</small>}
          </span>
        </Link>
      </div>

      {!isMobile && (
        <Link id="toggle_btn" to="#" onClick={handlesidebar}>
          <img src={baricon} alt="Menú" />
        </Link>
      )}

      {isMobile && (
        <Link
          id="mobile_btn"
          className="mobile_btn float-start"
          to="#"
          onClick={handlesidebarmobilemenu}
        >
          <img src={baricon1} alt="Menú" />
        </Link>
      )}

      <ul className="nav user-menu float-end">
        <li className="nav-item dropdown has-arrow">
          <Link
            to="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
          >
            <span className="user-img">
              <img src={user06} alt={displayName} />
              <span className="status online" />
            </span>
            <span className="user-label">
              <strong>{displayName}</strong>
              <small>{roleLabel}</small>
            </span>
          </Link>
          <div className="dropdown-menu dropdown-menu-end">
            <div className="user-header">
              <div className="avatar avatar-sm">
                <img src={user06} alt={displayName} className="avatar-img rounded-circle" />
              </div>
              <div className="user-text">
                <h6>{displayName}</h6>
                <p className="text-muted mb-0">{roleLabel}</p>
                {empresa && <p className="text-muted mb-0" style={{ fontSize: 12 }}>{empresa}</p>}
              </div>
            </div>
            <Link className="dropdown-item" to="/conf-cambio-contrasena">
              <FaKey className="me-2" />
              Cambiar contraseña
            </Link>
            <button type="button" className="dropdown-item" onClick={logout}>
              Cerrar sesión
            </button>
          </div>
        </li>
      </ul>

      <div className="dropdown mobile-user-menu float-end">
        <Link
          to="#"
          className="dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="fa-solid fa-ellipsis-vertical" />
        </Link>
        <div className="dropdown-menu dropdown-menu-end">
          <div className="px-3 py-2 border-bottom">
            <div className="fw-semibold">{displayName}</div>
            <div className="text-muted small">{roleLabel}</div>
          </div>
          <Link className="dropdown-item" to="/conf-cambio-contrasena">
            <FaKey className="me-2" />
            Cambiar contraseña
          </Link>
          <button type="button" className="dropdown-item" onClick={logout}>
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
